import moment from "moment";

export function formatDate(date: Date | null) {
  return date ? moment.utc(date).format("L") : "";
}
